import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const useScrollToSection = () => {
  const { hash } = useLocation();

  useEffect(() => {
    let wantedSection = hash && document.querySelector(hash);

    if (wantedSection) {
      wantedSection.scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
      });
    }
  }, [hash]);

  return null;
};
